/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Characteristics_TitleInputs */

const fr_vehicle_details_characteristics_title = /** @type {(inputs: Vehicle_Details_Characteristics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations du véhicule`)
};

const en_vehicle_details_characteristics_title = /** @type {(inputs: Vehicle_Details_Characteristics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vehicle information`)
};

/**
* | output |
* | --- |
* | "Vehicle information" |
*
* @param {Vehicle_Details_Characteristics_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_characteristics_title = /** @type {((inputs?: Vehicle_Details_Characteristics_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Characteristics_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_characteristics_title(inputs)
	return en_vehicle_details_characteristics_title(inputs)
});